import styled, { keyframes } from 'styled-components';

type ISpinnerSize = 'small' | 'medium' | 'large';

export interface ISpinnerProps {
  /** Enter a size for the spinner. (small | medium (default) | large) */
  size?: ISpinnerSize;
  /** Optional class name to apply to the spinner - allows for style extension */
  className?: string;
}

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const SpinnerContainer = styled.div<ISpinnerProps>`
  animation: ${spin} 1s infinite linear;
  border-radius: 50%;
  border: 0.25em solid rgba(22, 124, 250, 0.1);
  border-top-color: ${props => props.theme.vars.newColor.blue2};
  font-size: ${({ size }) => (size === 'small' ? 10.5 : size === 'large' ? 24 : 16)}px;
  height: 1.66em;
  width: 1.66em;
`;

export const Spinner = ({ className, size }: ISpinnerProps) => (
  <SpinnerContainer className={className} role="status" aria-label="loading" size={size} />
);
